import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { map } from 'rxjs/operators';
import { AffiliateDAO } from '../../../core/services/dao/affiliateDAO';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-affiliate-admin-manage-charter-display',
  templateUrl: './affiliate-admin-manage-charter-display.component.html',
  styleUrls: ['./affiliate-admin-manage-charter-display.component.scss'],
})
export class AffiliateAdminManageCharterDisplayComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  @Input()
  charterId: number;

  @Input()
  prefixText: string;

  @Input()
  resetComponentState = new Subject<boolean>();

  subs: Subscription[] = [];

  templateData$: Observable<{
    affInfo: ObservedValueOf<
      Observable<{ logoPath: string; displayName: string }>
    >;
  }>;

  constructor(private affiliateDAO: AffiliateDAO) {}

  ngOnInit() {
    this.initAsyncData();
    this.watchResetComponentState();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private initAsyncData(): void {
    this.templateData$ = this.affiliateDAO
      .getAffiliateNameAndPhotoByCharterId(this.charterId)
      .pipe(
        map((affInfo) => {
          return { affInfo };
        }),
      );
  }

  private watchResetComponentState(): void {
    if (this.resetComponentState) {
      const sub = this.resetComponentState.subscribe((reset) => {
        if (reset) {
          this.initAsyncData();
        }
      });
      this.subs.push(sub);
    }
  }
}
